import { toast } from "react-toastify";
import axiosInstance from "./axios.instance";


class CustomerService {

  async fetchCustomers() {
    try {
      const response = await axiosInstance.get("/customers");
      return response.data.data?.customers || [];
    } catch (err) {
      console.error("Error fetching customers:", err);
      return [];
    }
  }

  async fetchCustomerDetails(customerId=null) {
    try {
      const response = await axiosInstance.get(`/customers/${customerId}`);
      return response.data.data.data || null;
    } catch (err) {
      console.error("Error fetching customer:", err);
      throw new Error("Failed to fetch customer.");
    }
  }

  async updateCustomerProfile(customerId, profileData) {
    try {
      const response = await axiosInstance.put(`/customers/${customerId}`, profileData);
      return response.data;
    } catch (err) {
      console.error("Error updating customer profile:", err);
      throw err;
    }
  }

  async deleteCustomerAccount(customerId) {
    try {
      await axiosInstance.delete(`/customers/${customerId}`);
      toast.success("Account deleted successfully.");
    } catch (err) {
      console.error("Error deleting customer account:", err);
      throw err;
    }
  }

  async scheduleAppointment(customerId, vendorId, dateTime) {
    try {
      const response = await axiosInstance.post("/customers/time-slot/schedule", {
        customerId,
        vendorId,
        dateTime,
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  async fetchCustomerAppointments(customerId) {
    if (!customerId) {
      console.error("fetchCustomerAppointments: Missing customerId!");
      return [];
    }
    try {
      const response = await axiosInstance.get(`/customers/${customerId}/appointments`);
      return response.data.data?.appointments || [];
    } catch (err) {
      console.error("Error fetching customer appointments:", err);
      return [];
    }
  }

  async createLeadRequest (payload) {
    try {
      const response = await axiosInstance.post("/lead-requests", payload);
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  }
}

export default new CustomerService();
